<div class="responsible-config-background">
  @if (fg) {
    <form [formGroup]="fg" (submit)="update()">
      <table class="config-table">
        <tr>
          <td>
            <div class="config-column">
              <label for="playerRealityCheckPeriod">Player reality check period</label>
              @if (!editMode) {
                <span class="config-value-label">
                  {{ playerRealityCheckPeriodLabel }}
                </span>
              }
              @if (editMode) {
                <mat-select
                  class="period-select"
                  data-id="selectPlayerRealityCheckPeriodDropdownBtn"
                  formControlName="playerRealityCheckPeriod"
                  id="playerRealityCheckPeriod">
                  @for (period of POSSIBLE_PERIOD_OPTIONS; track period) {
                    <mat-option [attr.data-id]="'realityCheckPeriod_' + period" [value]="RealityCheckPeriod[period]">
                      {{ mapRealityCheckPeriodSecondsToLabel(RealityCheckPeriod[period]) }}
                    </mat-option>
                  }
                </mat-select>
              }
            </div>
          </td>
        </tr>
      </table>
      <div class="edit-container">
        @if (editMode) {
          @if (updatingInProgress) {
            <mat-spinner style="display: inline-block" [diameter]="20"></mat-spinner>
          }
          @if (!success && !updatingInProgress) {
            <button data-id="saveResponsibleGamingConfigBtn" mat-stroked-button color="primary" type="submit">
              Save
            </button>
          }
          @if (!success && !updatingInProgress) {
            <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        }
        @if (!editMode) {
          @if (!success) {
            <button
              data-id="editResponsibleGamingConfigBtn"
              mat-icon-button
              color="primary"
              type="submit"
              (click)="toggleEditMode()">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (success) {
            <strong style="color: green">Changes saved</strong>
          }
        }
      </div>
    </form>
  }
</div>
